import React, { useContext, useEffect, useState } from 'react';
import Select from "react-select";
import { selectStyle } from './selectStyle';
import { AppContext } from '../../../../providers/appProvider';
import cl from "./Sale.module.css"
import tbl from "../../../../assets/Style/Table.module.css";
import InvoiceModal from '../InvoiceModal/InvoiceModal';
import AgentInvoice from '../InvoiceModal/AgentInvoice';
import Form from "../../../../assets/Style/Form.module.css";
import CargoAmountModal from '../CargoAmountModal/CargoAmountModal';
import { useSalesAmount } from '../../../../hooks/useSalesAmount';

const Sale = ({ id, saleData, onUpdate, isView, isUpdate, updateInvoiceDetails, booking }) => {
    const initSaleModel = (saleData = {}) => {
        return {
            container_id: saleData.container_id || 0,
            bl_id: saleData.bl_id || 0,
            marine_line_id: saleData.marine_line_id || 0,
            bill_of_landing: saleData.bill_of_landing || "",
            amount: saleData.amount || 0,
            unit_id: saleData.unit_id || 0,
            agent_price: saleData.agent_price || 0,
            agent_invoice: saleData.agent_invoice || "",
            client_price: saleData.client_price || 0,
            client_invoice: saleData.client_invoice || "",
            // ფრახტი
            freight: saleData.freight || 0,
            // სატერმინალო
            terminal: saleData.terminal || 0,
            // შიდა გადაზიდვა
            domestic_shipping: saleData.domestic_shipping || 0,
            // დაზღვევა
            insurance: saleData.insurance || 0,
            // სხვა
            other: saleData.other || 0,
        };
    };

    const [newSale, setNewSale] = useState(initSaleModel(saleData));
    const [validates, setValidates] = useState({});
    const [totalClientPayment, setTotalClientPayment] = useState(0)
    const [totalCompanyPayment, setTotalCompanyPayment] = useState(0)
    const [companyDebt, setCompanyDebt] = useState(0)
    const [clientDebt, setClientDebt] = useState(0)
    const [billOfLandingFile, setBillOfLandingFile] = useState(null);
    const [agentInvoiceFile, setAgentInvoiceFile] = useState(null);
    const { saleAmountService } = useSalesAmount();
    

    const calculateClientPayment = (val) => {
        setTotalClientPayment(val)
    }

    const calculateCompanyPayment = (val) => {
        setTotalCompanyPayment(val)
    }

    const { appState } = useContext(AppContext);
    const marines = appState.marines.map((marine) => ({ value: marine.id, label: marine.name }));
    const agents = appState.agents.map((agent) => ({ value: agent.id, label: agent.name }));

    const unitOptions = [
        { value: 1, label: 'კონტეინერი' },
        { value: 2, label: 'პალეტი' },
        { value: 3, label: 'კუბი' },
        { value: 4, label: 'სატვირთო' },
    ];
    
    useEffect(() => {
        onUpdate(id, {
            ...newSale,
            getUploadFile:  () => billOfLandingFile,
            getUploadAgentFile: () => agentInvoiceFile, 
        });
    }, [billOfLandingFile, agentInvoiceFile]);


    useEffect(() => {

        const updateCargos = async () => {
            const allCargo = await saleAmountService.fetchBySaleId(id);
            const totals = allCargo.reduce(
                (acc, item) => {
                const type = item?.sale_amount_type;
                const amt = Number(item?.amount) || 0;
                if (type === 1) acc.client += amt;       
                else if (type === 2) acc.company += amt; 
                return acc;
                },
                { client: 0, company: 0 }
            );
    
            setTotalCompanyPayment(totals.company);
            setTotalClientPayment(totals.client)

            const sum = 
                (parseInt(newSale.freight) || 0) +
                (parseInt(newSale.terminal) || 0) +
                (parseInt(newSale.domestic_shipping) || 0) +
                (parseInt(newSale.insurance) || 0) +
                (parseInt(newSale.other) || 0);

            setClientDebt(Math.max(0, sum - totalClientPayment));
            setCompanyDebt(Math.max(0, newSale.agent_price - totalCompanyPayment))
        }

        updateCargos();

    }, [])

    console.log(totalCompanyPayment, totalClientPayment)
    
    useEffect(() => {
        if (saleData) {
            setNewSale(saleData);
        }
    }, [saleData]);
    
    useEffect(() => {
        if (isView) return;
        
        const sum = 
            (parseInt(newSale.freight) || 0) +
            (parseInt(newSale.terminal) || 0) +
            (parseInt(newSale.domestic_shipping) || 0) +
            (parseInt(newSale.insurance) || 0) +
            (parseInt(newSale.other) || 0);

        const updatedSale = {
            ...newSale,
            client_price: sum
        };
        
        setNewSale(updatedSale);
        
        if(isUpdate) {
            updateInvoiceDetails({
                total_price: sum,
                client_payment: totalClientPayment,
                container_fee: newSale.freight,
                thc_mh_fee: newSale.terminal,
                debit: sum - totalClientPayment,
                other_fee: newSale.domestic_shipping + newSale.insurance + newSale.other,
                container_number: newSale.container_id
            })
        }

        setClientDebt(sum - totalClientPayment < 0 ? 0 : sum - totalClientPayment);

        onUpdate && onUpdate(id, updatedSale);
    }, [newSale.freight, newSale.terminal, newSale.domestic_shipping, 
        newSale.insurance, newSale.other]);
    
    const handleChange = (event) => {
        if (isView) return;
        let val = convertToInt(event.target.value);
        const updatedSale = {
            ...newSale,
            [event.target.name]: val,
        };
        setNewSale(updatedSale);
        onUpdate && onUpdate(id, updatedSale);
    };

    function convertToInt(str) {
        const num = parseInt(str, 10);
        return isNaN(num) ? 0 : num;
    }

    const handleUnitChange = (selectedOption) => {
        if (isView) return;
        const updatedSale = {
            ...newSale,
            unit_id: selectedOption ? selectedOption.value : 0
        };
        setNewSale(updatedSale);
        onUpdate && onUpdate(id, updatedSale);
    };

    const handleAgentChange = (selectedOption) => {
        if (isView) return;
        const updatedSale = {
            ...newSale,
            agent_id: selectedOption ? selectedOption.value : 0
        };
        setNewSale(updatedSale);
        onUpdate && onUpdate(id, updatedSale);
    };

    const handleMarineLineChange = (selectedOption) => {
        if (isView) return;
        const updatedSale = {
            ...newSale,
            marine_line_id: selectedOption ? selectedOption.value : 0
        };
        setNewSale(updatedSale);
        onUpdate && onUpdate(id, updatedSale);
    };

    const stylesError = {
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            boxShadow: state.isFocused ? 'none' : 'none',
            '&:hover': {
                border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            },
            minHeight: "35px",
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
        }),
    };

    const readOnlySelectStyles = {
        control: (provided) => ({
            ...provided,
            backgroundColor: '#f8fafc',
            border: '1px solid #e2e8f0',
            cursor: 'default',
            pointerEvents: 'none',
            minHeight: "35px",
            width: '100%',
            borderRadius: '5px',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#1a202c',
        }),
    };

    const readOnlyInputStyle = {
        backgroundColor: '#f8fafc',
        border: '1px solid #e2e8f0',
        cursor: 'default',
        pointerEvents: 'none',
        color: '#1a202c',
    };

    return(
        <div>
            <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                <div style={{ width: '50%' }} className={validates && validates.freight ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}> 
                    <input
                        type="text"
                        name="freight"
                        className={Form.input}
                        onChange={handleChange}
                        value={newSale.freight}
                        placeholder='ფრახტი'
                        min="0"
                        style={isView ? readOnlyInputStyle : {}}
                        disabled={isView}
                    />
                    <label>ფრახტი</label>
                </div>
                <div style={{ width: '50%' }} className={validates && validates.terminal ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}> 
                    <input
                        type="text"
                        name="terminal"
                        className={Form.input}
                        onChange={handleChange}
                        value={newSale.terminal}
                        placeholder='სატერმინალო'
                        min="0"
                        style={isView ? readOnlyInputStyle : {}}
                        disabled={isView}
                    />
                    <label>სატერმინალო</label>
                </div>
                <div style={{ width: '50%' }} className={validates && validates.domestic_shipping ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}> 
                    <input
                        type="text"
                        name="domestic_shipping"
                        className={Form.input}
                        onChange={handleChange}
                        value={newSale.domestic_shipping}
                        placeholder='შიდა გადაზიდვა'
                        min="0"
                        style={isView ? readOnlyInputStyle : {}}
                        disabled={isView}
                    />
                    <label>შიდა გადაზიდვა</label>
                </div>
                <div style={{ width: '50%' }} className={validates && validates.insurance ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}> 
                    <input
                        type="text"
                        name="insurance"
                        className={Form.input}
                        onChange={handleChange}
                        value={newSale.insurance}
                        placeholder='დაზღვევა'
                        min="0"
                        style={isView ? readOnlyInputStyle : {}}
                        disabled={isView}
                    />
                    <label>დაზღვევა</label>
                </div>
                <div style={{ width: '50%' }} className={validates && validates.agent_id ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}> 
                    <input
                        type="text"
                        name="other"
                        className={Form.input}
                        onChange={handleChange}
                        value={newSale.other}
                        placeholder='სხვა'
                        min="0"
                        style={isView ? readOnlyInputStyle : {}}
                        disabled={isView}
                    />
                    <label>სხვა</label>
                </div>
            </fieldset>
    
            <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
    
                <div style={{ width: '50%' }}  className={validates && validates.agent_id ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}> 
                    <Select
                        styles={isView ? readOnlySelectStyles : (validates && validates.agent_id ? { ...selectStyle, ...stylesError } : selectStyle)}
                        placeholder=""
                        options={agents}
                        value={agents.find(option => option.value === newSale.agent_id)}
                        onChange={handleAgentChange}
                        isDisabled={isView}
                    />
                    <label >აგენტი</label> 
                </div>
                
                {
                    booking.type_id == 2 ? <></> :
                    <div style={{width:'50%'}} className={validates && validates.marine_line_id ? cl.groupInput + ' ' + cl.errorInput : cl.groupInput}> 
                        <label >საზღვაო ხაზი</label> 
                        <Select
                            styles={isView ? readOnlySelectStyles : (validates && validates.marine_line_id ? { ...selectStyle, ...stylesError } : selectStyle)}
                            placeholder=""
                            options={marines}
                            value={marines.find(option => option.value === newSale.marine_line_id)}
                            onChange={handleMarineLineChange}
                            isDisabled={isView}
                        />
                    </div>                  
                }

                
            </fieldset>
            {/* Container stuff */}
            <div className={tbl.table + " " + cl.table}>
                <table>
                    <thead>
                        <tr>
                            <th className={cl.pad2}>კონტეინერის #</th>
                            <th className={cl.pad2}>BL #</th>
                            <th className={cl.pad2}>Bill of Landing</th>
                            <th className={cl.pad2}>რაოდენობა</th>
                            <th className={cl.pad2}>ერთეული</th>
                            <th className={cl.pad2}>აგენტის ფასი</th>
                            {isUpdate && (
                            <>
                                <th className={cl.pad2}>კომპანიის გადახდა</th>
                                <th className={cl.pad2}>კომპანიის დავალიანება</th>
                            </>
                            )}
                                <th className={cl.pad2}>აგენტის ინვოისი</th>
                                <th className={cl.pad2}>კლიენტის ფასი</th>
                            {isUpdate && (
                            <>
                                <th className={cl.pad2}>კლიენტის გადახდა</th>
                                <th className={cl.pad2}>კლიენტის დავალიანება</th>
                            </>
                            )}

                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {/* კონტეინერის # */}
                            <td>
                                <input
                                    type="text"
                                    name="container_id"
                                    className={Form.input}
                                    onChange={handleChange}
                                    value={newSale.container_id}
                                    min="0"
                                    style={isView ? readOnlyInputStyle : {}}
                                    disabled={isView}
                                />
                            </td>
                            {/* BL # */}
                            <td>
                                <input
                                    type="text"
                                    name="bl_id"
                                    className={Form.input}
                                    onChange={handleChange}
                                    value={newSale.bl_id}
                                    min="0"
                                    style={isView ? readOnlyInputStyle : {}}
                                    disabled={isView}
                                />
                            </td>
                            {/* Bill of Landing */}
                            <td>

                                <InvoiceModal
                                    defaultSale={newSale}
                                    onFileSelect={file => setBillOfLandingFile(file)}
                                    isView={isView}
                                />
                
                            </td>
                            {/* რაოდენობა */}
                            <td>
                                <input
                                    type="text"
                                    name="amount"
                                    className={Form.input}
                                    onChange={handleChange}
                                    value={newSale.amount}
                                    min="0"
                                    style={isView ? readOnlyInputStyle : {}}
                                    disabled={isView}
                                />
                            </td>
                            {/* ერთეული */}
                            <td>
                            <Select
                                styles={isView ? readOnlySelectStyles : selectStyle}
                                options={unitOptions}
                                value={unitOptions.find(option => option.value === newSale.unit_id)}
                                onChange={handleUnitChange}
                                placeholder="ერთეული"
                                isDisabled={isView}
                            />
                            </td>
                            {/* აგენტის ფასი */}
                            <td>                                
                                <input
                                    type="text"
                                    name="agent_price"
                                    className={Form.input}
                                    onChange={handleChange}
                                    value={newSale.agent_price}
                                    min="0"
                                    style={isView ? readOnlyInputStyle : {}}
                                    disabled={isView}
                                />
                            </td>

                            {isUpdate && (
                                <>
                                    <td>
                                        <CargoAmountModal sale={newSale} saleAmountType={2} calculatePayment={calculateCompanyPayment} isView={isView}></CargoAmountModal>
                                    </td>

                                    <td>
                                        {companyDebt}$
                                    </td>
                                </>
                            )}


                            {/* აგენტის ინვოისი */}
                            <td>
                                <AgentInvoice
                                    defaultSale={newSale}
                                    isView={isView}
                                    onFileSelect={file => setAgentInvoiceFile(file)}
                                />
                            </td>
                            {/* კლიენტის ფასი */}
                            <td>
                                <input
                                    type="text"
                                    name="client_price"
                                    className={Form.input}
                                    onChange={handleChange}
                                    readOnly
                                    value={newSale.client_price}
                                    min="0"
                                    style={isView ? readOnlyInputStyle : {}}
                                    disabled={isView}
                                />
                            </td>
                            {/* კლიენტის ინვოისი */}
                            {isUpdate && (
                            <>
                                <td>
                                    <CargoAmountModal sale={newSale} saleAmountType={1} calculatePayment={calculateClientPayment} isView={isView}></CargoAmountModal>
                                </td>
                                <td>
                                    {clientDebt}$
                                </td>
                            </>
                            )}

                        </tr>    
                    </tbody>
                </table>
            </div>
        </div>
    )
} 
export default Sale;